import React, { useEffect, useRef, useState } from "react";
import style from "./index.module.css"
import kiosk from "./Kiosk.module.css"

const useRefDimensions = (ref) => {
  const [dimensions, setDimensions] = useState(1);
  const getElementWidth=()=>{
    if (ref.current) {
      const { current } = ref;
      const width = current.clientWidth;
      setDimensions(width);
    }
  }
  useEffect(() => {  
    window.addEventListener('resize', getElementWidth);
    return () => window.removeEventListener('resize', getElementWidth);
  }, [])
  return dimensions;
}


const BenefitsCard = ({ benefit }) => {
  let classes= window.location.pathname==="/use-case-self-order-kiosk" ?
  style : kiosk;
  const cardRef=useRef();
  const width = useRefDimensions(cardRef);

  return (
    <div id="benefitCard" className={classes.card} ref={cardRef}>
      <img src={benefit.img} alt={benefit.title} />
      <p className={width && width<220 && classes.active}>{benefit.title}</p>
    </div>
  );
};

export default BenefitsCard;
